import * as yup from 'yup';
import { FIELD_REQUIRED_MSG } from '../../validation';
import {
  MAX_WEIGHT,
  MIN_WEIGHT,
  WEIGHT_ERROR,
  WEIGHT_FORMAT_ERROR,
} from './constants';

export const schema = yup.object().shape({
  weight: yup
    .number()
    .required(FIELD_REQUIRED_MSG)
    .integer(WEIGHT_FORMAT_ERROR)
    .typeError(FIELD_REQUIRED_MSG)
    .max(MAX_WEIGHT, WEIGHT_ERROR)
    .min(MIN_WEIGHT, WEIGHT_ERROR),
  idealWeight: yup
    .number()
    .integer(WEIGHT_FORMAT_ERROR)
    .nullable()
    .typeError(FIELD_REQUIRED_MSG)
    .max(MAX_WEIGHT, WEIGHT_ERROR)
    .min(MIN_WEIGHT, WEIGHT_ERROR)
    .transform(v => (isNaN(v) ? null : v)),
});
